import { cx, Flex, Text } from '@vtex/admin-ui'
import { Checkbox, FormState, useWatch } from '@vtex/admin-ui-form'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { NumberInput } from '../../../../../../NumberInput'
import { messages } from '../../messages'
import styles from '../style.css'

type Props = {
  form: FormState
  className?: string
}

const MIN_VALUE = 1
const FIELD_NAME = 'limit'
enum Field {
  VALUE = `${FIELD_NAME}.value`,
  CHECKED = `${FIELD_NAME}.checked`,
}

export function MaxUsage(props: Props) {
  const { form, className } = props

  const { $t } = useIntl()

  const { checked, value } = useWatch({ form, name: FIELD_NAME })

  useEffect(() => {
    if (!checked) {
      form.resetField(FIELD_NAME)
      form.setValue(Field.VALUE, undefined)
    } else {
      form.setValue(Field.VALUE, MIN_VALUE)
    }
  }, [checked, form])

  return (
    <div className={className}>
      <Checkbox
        state={form}
        label={$t(messages.editor.maxUsage.title)}
        name={Field.CHECKED}
        helpText={$t(messages.editor.maxUsage.helpText)}
      />

      {checked && (
        <Flex
          align="baseline"
          className={cx(styles.checkboxContent, styles.numberBox)}
        >
          <NumberInput
            name={Field.VALUE}
            state={form}
            min={MIN_VALUE}
            fractionDigits={0}
            aria-label={$t(messages.editor.maxUsage.aria)}
          />

          <Text tone="secondary">
            {$t(messages.editor.maxUsage.times, { value })}
          </Text>
        </Flex>
      )}
    </div>
  )
}
